module.exports = __webpack_public_path__ + "static/media/DSC02357.1fe41414.jpg";